export default {
  blockPrices: [],
  priceCategories: [],
  tmpBooking: null,
  client: null,
}
